module.exports = __webpack_public_path__ + "img/mbsl.305e07a7.jpg";